/* Breadcrumb routing shares the catalogue's category graph and destinations. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else root.CabaneBreadcrumbRoutes = factory(root.CabaneCategoryNavigation);
})(typeof window === 'undefined' ? globalThis : window, function (data) {
  'use strict';
  const groups = data?.groups || {};
  const rootKeys = new Set((groups.catalogue?.items || []).map(item => item.group));
  const plainPath = path => path.replace(/^\/en(?=\/|$)/, '').replace(/\/$/, '') || '/';
  const groupURL = key => groups[key]?.productUrl || groups[key]?.url;
  const readURL = (value, base) => { try { const url = new URL(value, base); return url.origin === base.origin ? url : null; } catch (_) { return null; } };
  const matches = (value, current) => {
    if (!value) return false;
    const target = readURL(value, current);
    if (!target || plainPath(target.pathname) !== plainPath(current.pathname)) return false;
    if (plainPath(target.pathname) === '/search') {
      const expected = target.searchParams.get('q'), actual = current.searchParams.get('q') || '';
      return !!expected && (actual === expected || actual.startsWith('(' + expected + ') AND '));
    }
    return true;
  };
  const recognizes = (key, url) => !!groups[key] && (matches(groupURL(key), url) || groups[key].items.some(item => matches(item.url, url)));
  function naturalChain(key) {
    const chain = [], seen = new Set();
    while (key && key !== 'catalogue' && groups[key] && !seen.has(key)) {
      seen.add(key); chain.unshift(key); key = groups[key].parent;
    }
    return chain;
  }
  function contextualChain(key, universe) {
    if (!rootKeys.has(universe)) return naturalChain(key);
    // Shared categories can be reached through several universes. Follow the
    // actual catalogue edges instead of their single default parent.
    const queue = [[universe]], seen = new Set();
    while (queue.length) {
      const chain = queue.shift(), last = chain[chain.length - 1];
      if (last === key) return chain;
      if (seen.has(last)) continue;
      seen.add(last);
      for (const item of groups[last]?.items || []) {
        if (item.group && groups[item.group] && !chain.includes(item.group)) queue.push([...chain, item.group]);
      }
    }
    return naturalChain(key);
  }
  function resolve(value, title, localeRoot = '/') {
    const url = value instanceof URL ? value : new URL(value, 'https://local.invalid');
    const handle = plainPath(url.pathname).match(/^\/collections\/([^/]+)$/)?.[1];
    const override = url.searchParams.get('navigation');
    let key = recognizes(override, url) ? override : data?.mapping?.[handle];
    if (!groups[key] || key === 'catalogue') {
      key = Object.keys(groups).find(candidate => candidate !== 'catalogue' && recognizes(candidate, url));
    }
    if (!groups[key] || key === 'catalogue') return null;
    const keys = contextualChain(key, url.searchParams.get('univers'));
    const universe = keys[0];
    const root = localeRoot.replace(/\/$/, '');
    const destination = (value, navigation) => {
      const target = readURL(value, url);
      if (!target) return null;
      target.pathname = root + plainPath(target.pathname);
      if (navigation) target.searchParams.set('navigation', navigation);
      if (rootKeys.has(universe)) target.searchParams.set('univers', universe);
      if (url.searchParams.has('preview_theme_id')) target.searchParams.set('preview_theme_id', url.searchParams.get('preview_theme_id'));
      return target.pathname + target.search + target.hash;
    };
    const items = keys.filter(k => groupURL(k)).map(k => ({title:groups[k].label, url:destination(groupURL(k), k)}));
    if (matches(groupURL(key), url)) {
      // Collections have their own full label, e.g. "Skateboards complets".
      if (handle && title && items.length) items[items.length - 1].title = title;
      return items;
    }
    const item = groups[key].items.find(item => matches(item.url, url));
    if (handle) {
      items.push({title:title || item?.label || handle, url:destination('/collections/' + handle, key)});
    } else if (item) {
      items.push({title:item.label, url:destination(item.url, key)});
    } else return null;
    return items;
  }
  return {resolve, contextualChain};
});
